// extracted by mini-css-extract-plugin
export default {"container":"container__ZIGAv","title":"title__7rKA2","subtitle":"subtitle__6VItq","list":"list__1M4Y7"};